import { IBusinessUnit, IRegisterWithOwner } from "../../models";

/**
 * Registers arrive flat (`toRegisters` already discarded the ДПС nesting), so
 * screens regroup them by `taxObjectId` to show каси under their торгова
 * точка, in the order the tax objects were first seen.
 */
export const groupRegistersByBusinessUnit = (
  registers: IRegisterWithOwner[],
): IBusinessUnit[] => {
  const units: IBusinessUnit[] = [];
  const indexByTaxObjectId = new Map<string, number>();

  registers.forEach(register => {
    const existingIndex = indexByTaxObjectId.get(register.taxObjectId);

    if (existingIndex !== undefined) {
      units[existingIndex].registers.push(register);
      return;
    }

    indexByTaxObjectId.set(register.taxObjectId, units.length);
    units.push({
      taxObjectId: register.taxObjectId,
      name: register.businessUnitName,
      address: register.address,
      registers: [register],
    });
  });

  return units;
};
